import { compose } from 'redux';
import { connect } from 'react-redux';
import CountdownView from '../../../../common/countdown/countdownView';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { goToQuestion } from '../../../../common/navigation/navigationActions';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { VOCAB } from '../../../../constants/measure';
import { getAvatarPosition } from '../../../../common/alex/AlexUtils';

const mapDispatchToProps = dispatch => {
    return {
        onEndCounting: () => {
            dispatch(goToQuestion(VOCAB.ASSESSMENT, VOCAB.TQVM, 1));
        },
        cleanup: () => {
            dispatch(unmountScreen());
        },
    };
};

const avatarProps = () => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
    };
};

const VocabTQVMCountdownContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarProps),
)(CountdownView);

export default VocabTQVMCountdownContainer;
